<template>
  <tr class="man-wrap" :class="{ rows__single: type === 'rows', cp: cp }"
      @click="photo.includes('.pdf') ? '' : $emit('open')">
    <!-- Карточка -->
    <div class="cards__single" v-if="type === 'cards'">
      <span class="photo bcard__photo" v-if="photo">
      <img :src="$hostname + 'time-tracking/preview/' + photo" alt="default"/>
      </span>

      <div class="cards__main-info">
        <h2 v-if="title">
          <a v-if="photo.includes('.pdf')" class="link-not-like" @click.stop="" target="_blank"
             :href="$media_url+photo">
            {{ title }}
          </a>
          <span v-else class="link-not-like">{{ title }}</span>
        </h2>
      </div>

      <div class="cards__buttons">
        <button
            v-if="showEdit"
            class="btn-icon btn-action"
            @click.stop="$emit('edit')"
        >
          <edit-icon/>
        </button>

        <button
            v-if="showArchive && hasActive"
            class="btn-icon btn-action"
            @click.stop="$emit('archive')"
        >
          <archive-icon/>
        </button>

        <button
            v-if="showDelete && (isArchived || !hasActive)"
            class="btn-icon btn-action"
            @click.stop="$emit('delete')"
        >
          <delete-icon/>
        </button>
        <button v-if="showLoad" class="btn-icon btn-action"
                @click.stop="$emit('download-document')">
          <download-icon/>
        </button>
      </div>

      <ul class="cards__info">
        <template v-for="(item, index) in options">
          <li :key="index" v-if="item.value">
            <span v-html="item.icon"></span>
            <span v-html="item.value"></span>
          </li>
        </template>
      </ul>
    </div>

    <!-- Строка -->
    <template v-if="type === 'rows'">
      <td v-if="photo">
        <div class="avatar" v-if="photo">
          <!--          <img v-if="photo" :src="photo" alt=""/>-->

          <img class="document-row__photo"
               :src="$hostname + 'time-tracking/preview/' + photo"
               @click.stop="$emit('open-photo')"/>
        </div>
      </td>
      <template v-for="(header) in headers">
        <template v-if="showHeaders[header.key]">
          <td v-if="header.key.indexOf('date') > -1" :key="header.key">
            {{ new Date(card[header.key]).toLocaleDateString() }}
          </td>
          <td v-else-if="header.key == 'name' && photo.includes('.pdf')" :key="header.key">
            <a class="link-not-like" @click.stop="" target="_blank"
               :href="$media_url+photo">
              {{ title }}
            </a>
          </td>
          <td v-else v-html="card[header.key]" :key="header.key"></td>
        </template>
      </template>
      <td v-if="showArchive || showEdit || showDelete|| showLoad" class="rows__dot-menu">
        <v-menu bottom right>
          <template v-slot:activator="{ on, attrs }">
            <v-btn dark icon v-bind="attrs" v-on="on">
              <svg
                  width="20"
                  height="5"
                  viewBox="0 0 20 5"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="2" cy="2.5" r="2" fill="#2C1521"/>
                <circle cx="10" cy="2.5" r="2" fill="#2C1521"/>
                <circle cx="18" cy="2.5" r="2" fill="#2C1521"/>
              </svg>
            </v-btn>
          </template>
          <div class="rows__dot-menu-content">
            <div class="btn-wrap" @click.stop="$emit('edit')" v-if="showEdit">
              {{ $vuetify.lang.t('$vuetify.edit') }}
              <button class="btn-icon btn-action">
                <edit-icon/>
              </button>
            </div>
            <div
                class="btn-wrap"
                @click.stop="$emit('archive')"
                v-if="showArchive && hasActive"
            >
              <span v-if="card.active">{{ $vuetify.lang.t('$vuetify.toArchive') }}</span>
              <span v-else>{{ $vuetify.lang.t('$vuetify.deleteArchive') }}</span>
              <button class="btn-icon btn-action">
                <archive-icon/>
              </button>
            </div>
            <div
                class="btn-wrap"
                @click.stop="$emit('delete')"
                v-if="showDelete && (isArchived || !hasActive)"
            >
              {{ $vuetify.lang.t('$vuetify.delete') }}
              <button class="btn-icon btn-action">
                <delete-icon/>
              </button>
            </div>
            <div class="btn-wrap" @click="$emit('download-document')" v-if="showLoad">
              {{ $vuetify.lang.t('$vuetify.loadDoc') }}
              <button class="btn-icon btn-action">
                <document-icon/>
              </button>
            </div>
          </div>
        </v-menu>
      </td>
    </template>
  </tr>
</template>

<script>
import EditIcon from "@/components/icons/EditIcon";
import ArchiveIcon from "@/components/icons/ArchiveIcon";
import DeleteIcon from "@/components/icons/DeleteIcon";
import DocumentIcon from "@/components/icons/DocumentIcon.vue";
import DownloadIcon from "@/components/icons/DownloadIcon.vue";

export default {
  name: "BaseCard",

  components: {
    DownloadIcon,
    DocumentIcon,
    EditIcon,
    ArchiveIcon,
    DeleteIcon,
  },

  props: {
    type: {
      type: String,
      default: "cards", // или "rows"
    },
    cp: {
      type: Boolean,
      default: false, // или "rows"
    },
    title: {
      type: [String, undefined],
      required: true
    },
    photo: {
      type: String,
      default: "",
    },
    options: {
      type: Array,
      default: () => [],
    },
    showEdit: {
      type: Boolean,
      default: true,
    },
    showArchive: {
      type: Boolean,
      default: true,
    },
    showDelete: {
      type: Boolean,
      default: true,
    },
    showLoad: {
      type: Boolean,
      default: true,
    },
    card: {
      type: Object,
      default: () => ({}),
    },
    headers: {
      type: Array,
      default: () => ([])
    },
    showHeaders: {
      type: Object,
      default: () => ({})
    },
  },

  computed: {
    hasActive() {
      return Object.prototype.hasOwnProperty.call(this.card, "active");
    },
    isArchived() {
      return this.card.active === false;
    },
  },
};
</script>

<style scoped>
</style>